<template>
  <section v-if="list.length" class="mt-5">
    <div class="row no-gutters">
      <div class="col pl-2 list-heading">
        {{ $t('reports.supplier-reports-search.service-code') }}
      </div>
<!--      <div class="col pl-2 list-heading">
        {{ $t('reports.supplier-reports-search.status-code') }}
      </div>-->
      <div class="col pl-2 list-heading">
        {{ $t('reports.supplier-reports-search.ledger-code') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.supplier-reports-search.number-of-items') }}
      </div>
      <div class="col pl-2 list-heading">
        {{ $t('reports.supplier-reports-search.type') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.supplier-reports-search.purchase-price') }}
      </div>
      <div class="col pl-3 list-heading">
        {{ $t('reports.supplier-reports-search.sale-price') }}
      </div>
    </div>
    <ul class="row input-table mt-2">
      <reports-supplier-reports-list-item
        v-for="(report, index) in list"
        :key="index"
        :item="report"
      ></reports-supplier-reports-list-item>
    </ul>
  </section>
</template>
<script>
export default {
  props: {
    list: {
      default: () => [],
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>
.list-heading {
  font-family: 'Open Sans Bold';
  font-size: 14px;
  color: #767676;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/supplier-reports/List.vue